import { render, staticRenderFns } from "./CopilotoMensaje.vue?vue&type=template&id=450a37e9&"
import script from "./CopilotoMensaje.vue?vue&type=script&lang=ts&"
export * from "./CopilotoMensaje.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('450a37e9', component.options)
    } else {
      api.reload('450a37e9', component.options)
    }
    module.hot.accept("./CopilotoMensaje.vue?vue&type=template&id=450a37e9&", function () {
      api.rerender('450a37e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Mensaje/CopilotoMensaje.vue"
export default component.exports